<template>
  <div class="flex items-center flex-col gap-6 p-6">
    <span class="text-center">Please update the app to the latest version.</span>
    <img
      alt="SyncFDY Logo"
      class="w-64 h-64 mx-auto"
      :class="{ 'animated': animateImage }"
      :src="LogoImage"
    >
    <Button
      :disabled="animateImage"
      class="w-36"
      severity="primary"
      label="Update"
      @click="updateApp"
    />
  </div>
</template>
<script setup>
import LogoImage from '@/assets/logo.png?w=256&h=256&format=webp&imagetools'
import { inject, ref } from 'vue'

const dialogRef = inject('dialogRef')
const animateImage = ref(false)

const updateApp = () => {
  animateImage.value = true
  setTimeout(() => {
    dialogRef.value.data.updateSw()
  }, 1000)
}
</script>
<style>
@keyframes rotazione {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

img.animated {
  animation: rotazione 2s linear infinite;
}
</style>
